import "../../sass/pages/_agegate.scss";

(function page() {
  console.log("agegate");
})();

console.log("start js");

addEventListener("scroll", (event) => {
  if (document.body.classList.contains("agegate-visible")) {
    document.querySelector("div#footer__paco")?.classList.add("hidden");
  } else {
    document.querySelector("div#footer__paco")?.classList.remove("hidden");
  }
});

const setSocialAriaLabel = () => {
  let fb_icons = document.querySelectorAll(".paco__social--facebook");
  let ig_icons = document.querySelectorAll(".paco__social--instagram");
  let tw_icons = document.querySelectorAll(".paco__social--twitter");
  let yt_icons = document.querySelectorAll(".paco__social--youtube");
  fb_icons.forEach((element) => {
    element.setAttribute("aria-label", "Logo Facebook");
  });
  ig_icons.forEach((element) => {
    element.setAttribute("aria-label", "Logo Instagram");
  });
  tw_icons.forEach((element) => {
    element.setAttribute("aria-label", "Logo Twitter");
  });
  yt_icons.forEach((element) => {
    element.setAttribute("aria-label", "Logo Youtube");
  });
};

const bgtransparent = () => {
  let bgimage = document.querySelector(".bgimage");

  if (bgimage) {
    document
      .querySelector("#block-hubvictoria-content>article")
      ?.classList.add("bgtela");
    document.querySelector("#tienda")?.classList.add("bgtransparent");
    document.querySelector(".picture__banner")?.classList.add("nofilter");
  } else {
    document.querySelector("#tienda")?.classList.remove("bgtransparent");
    document.querySelector(".picture__banner")?.classList.remove("nofilter");
    document
      .querySelector("#block-hubvictoria-content>article")
      ?.classList.remove("bgtela");
  }
};

const selectFeria = () => {
  if (document.querySelector(".card")) {
    const selectElement = document.getElementById(
      "mySelect"
    ) as HTMLSelectElement;
    const buttonElement = document.getElementById(
      "myButton"
    ) as HTMLAnchorElement;

    selectElement.addEventListener("change", () => {
      const selectedValue = selectElement.value;
      if (selectedValue !== "") {
        buttonElement.href = selectedValue;
      }
    });
  }
};

const assignCardLink = () => {
  const cardContainers = document.querySelectorAll(".card");

  cardContainers.forEach((cardcontainer) => {
    const btnlink = cardcontainer.querySelector(
      ".btn__card__fair"
    ) as HTMLAnchorElement;
    const hrefbtnlink = btnlink.href;

    const linkCard = cardcontainer.querySelector(
      ".card__link"
    ) as HTMLAnchorElement;

    linkCard.href = hrefbtnlink;

    if (btnlink.classList.contains("unactive")) {
      linkCard.classList.add("unactive");
    } else {
      linkCard.classList.remove("unactive");
    }
  });
};

const setmarketBtnMobile = () => {};

function isMobileDevice(): boolean {
  return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
    (navigator as Navigator).userAgent
  );
}

function addMobileContent(): void {
  if (isMobileDevice()) {
    const customContent = document.createElement("div");
    customContent.innerHTML =
      '<a id="iconCart" class="iconCart" target="" href="/#tienda"></a>';
    const logoElement = document.querySelector(".menu__header--logo");
    if (logoElement && logoElement.parentNode) {
      logoElement.parentNode.insertBefore(
        customContent,
        logoElement.nextSibling
      );
    }
  }
}

function toggleLegalPanel(): void {
  const legalAccordion = document.querySelector(".legal_accordion");
  const legalPanel = document.querySelector(".legal_panel");

  if (legalAccordion && legalPanel) {
    legalAccordion.addEventListener("click", () => {
      if ((legalPanel as HTMLElement).style.display === "none") {
        (legalPanel as HTMLElement).style.display = "block !important";
      } else {
        (legalPanel as HTMLElement).style.display = "none !important";
      }
    });
  }
}

function setBigImgCard(): void {
  if (document.querySelectorAll(".panam__card--img").length > 0) {
    document.querySelectorAll(".panam__card--img")[0].classList.add("bigImg");
    document.querySelectorAll(".panam__card--img")[1].classList.add("bigImg");
  }
}

function playModalVideo(): void {
  let valid = document.querySelector(".panam__video");
  console.log("valid", valid);

  if (valid) {
    console.log("sdsds");
  }
}

function showGoUpBtn() {
  const goDownBtn = document.querySelector(".goDownBtn");
  const fixedUp = document.querySelector(".fixedUp");

  if (goDownBtn && fixedUp) {
    window.addEventListener("scroll", () => {
      const goDownBtnRect = goDownBtn.getBoundingClientRect();
      const fixedUpRect = fixedUp.getBoundingClientRect();
      if (goDownBtnRect.bottom > 0) {
        fixedUp.classList.add("hidden");
      } else {
        fixedUp.classList.remove("hidden");
      }
    });
  }
}

function pageLoader(): void {
  window.addEventListener("load", function () {
    let loader = document.querySelector(".loader");
    if (loader) {
      loader.classList.add("loaded");
    }
  });
}

function playVideo(): void {
  let playBtn = document.querySelector(".start-video");
  if (playBtn) {
    playBtn?.addEventListener("click", () => {
      let iframeBox = document.querySelector(".modal");
      let linkYt = document.querySelector(".linkYT")?.textContent;
      let iframe = document.querySelector(".iframePanam") as HTMLIFrameElement;
      console.log("linkYt", linkYt);
      iframeBox?.classList.add("active");
      if (iframe) {
        let videoURL = "https://www.youtube.com/embed/LIUg2n-oAEc?controls=0";
        iframe.setAttribute("src", videoURL + "&enablejsapi&autoplay=1");
      }

      let closeBtn = document.querySelector(".closeModal");
      closeBtn?.addEventListener("click", () => {
        console.log("close");
        iframeBox?.classList.remove("active");
        if (iframe) {
          let videoURL = "https://www.youtube.com/embed/LIUg2n-oAEc?controls=0";
          iframe.setAttribute("src", videoURL);
        }
      });
    });
  }
}

if (window.location.href.includes("dia-de-muertos")) {
  window.addEventListener("load", () => {
    console.log("godown");
    setTimeout(() => {
      if (document.querySelector(".heaven")) {
        window.scrollTo(0, document.body.scrollHeight);
      }
    }, 1000);
  });
}

(function page() {
  console.log("Cargar contenido agegate !!!!!!!!!!!!!!!!!");
  
  pageLoader();
  playModalVideo();
  toggleLegalPanel();
  // bgtransparent();
  setSocialAriaLabel();
  selectFeria();
  assignCardLink();
  setmarketBtnMobile();
  addMobileContent();
  setBigImgCard();
  showGoUpBtn();
  playVideo();
})();
